module.exports = __webpack_public_path__ + "img/companyIntro3.f9fceff3.png";